import React from "react";
import Comment from "./Comment";
import StatusChange from "./StatusChange";

const Activity = ({ activity, ...otherProps }) => {
  switch (activity.activityType) {
    case "job_comment":
      return <Comment activity={activity} {...otherProps} />;
    case "job_status_change":
    case "service_status_change":
      return <StatusChange activity={activity} {...otherProps} />;
    default:
      return null;
  }
};

export default Activity;



// WEBPACK FOOTER //
// ./src/components/activities/Activity.js